export default __webpack_public_path__ + "static/media/pc_background3@3x.a2c0ef59.png";